import React, { createContext, useReducer } from "react";

const initialState = { orderId: "", orderNumber: "", itemsState: [] };

export const ChargeItemsContext = createContext({
    state: initialState,
    contextDispatch: () => undefined,
});

export const ActionTypes = {
    ADD_ITEM: "ADD_ITEM",
    INCREASE_NUMBER: "INCREASE_NUMBER",
    REDUCE_NUMBER: "REDUCE_NUMBER",
    CLEAR_ITEMS: "CLEAR_ITEMS",
    INITIATE_ORDER: "INITIATE_ORDER",
    RESET_ORDER: "RESET_ORDER",
    UPDATE_SAVED_ORDER: "UPDATE_SAVED_ORDER",
};

const ChargeItemsProvider = ({ children }) => {
    const [state, contextDispatch] = useReducer(chargeItemsReducer, initialState);

    return (
        <ChargeItemsContext.Provider value={{ state, contextDispatch }}>
            {children}
        </ChargeItemsContext.Provider>
    );
};

const chargeItemsReducer = (state, action) => {
    switch (action.type) {
        case ActionTypes.ADD_ITEM: {
            const currrentAdded = state.itemsState.find((item) => item.id === action.payload.id);
            if (currrentAdded) return { ...state };
            return {
                ...state,
                itemsState: [
                    ...state.itemsState,
                    {
                        name: action.payload.name,
                        number: 1,
                        defaultPrice: action.payload.price,
                        currentPrice: action.payload.price,
                        id: action.payload.id,
                    },
                ],
            };
        }
        case ActionTypes.INCREASE_NUMBER: {
            const updatedItem = state.itemsState.map((item) =>
                item.id === action.payload
                    ? {
                          ...item,
                          number: item.number + 1,
                          currentPrice: item.defaultPrice * (item.number + 1),
                      }
                    : item,
            );
            return { ...state, itemsState: updatedItem };
        }
        case ActionTypes.REDUCE_NUMBER: {
            const updatedItem = state.itemsState
                .map((item) => {
                    if (item.id === action.payload) {
                        const newNumber = item.number - 1;
                        if (newNumber < 1) return null;
                        return {
                            ...item,
                            number: newNumber,
                            currentPrice: item.defaultPrice * newNumber,
                        };
                    }
                    return item;
                })
                .filter((item) => item !== null);

            return { ...state, itemsState: updatedItem };
        }
        case ActionTypes.INITIATE_ORDER: {
            return {
                ...state,
                orderId: action.payload.id,
                orderNumber: action.payload.orderID,
            };
        }
        case ActionTypes.UPDATE_SAVED_ORDER: {
            return {
                ...state,
                orderId: action.payload.id,
                orderNumber: action.payload.orderID,
                itemsState: action.payload?.items?.map((item) => ({
                    name: item.name,
                    number: item.quantity,
                    defaultPrice: item.unitPrice,
                    currentPrice: item.unitPrice * item.quantity,
                    id: item.id,
                })),
            };
        }
        case ActionTypes.CLEAR_ITEMS: {
            return {
                ...state,
                itemsState: [],
            };
        }
        case ActionTypes.RESET_ORDER: {
            return {
                ...initialState,
            };
        }

        default:
            return state;
    }
};

export default ChargeItemsProvider;
